import gql from 'graphql-tag';
import { GetAllTicketNumbersQuery } from '.';
import { OperatorInputOperatorFragment } from '../../fields/OperatorInput/index';
import { LeaseInputLeaseFragment } from '../../fields/LeaseInput/index';

const UpdateMissingTicketDetailsMutation = gql`
  mutation UpdateExpectedJobFacts($input: UpdateExpectedJobFactsInput!) {
    expected_job_facts_update(input: $input) {
      id
      number
      district {
        id
        name
      }
      department {
        id
        name
      }
      operator {
        id
        name
        lookup {
          ...OperatorInputOperatorLookup
        }
      }
      lease {
        id
        name
        lookup {
          ...LeaseInputLease
        }
      }
      jobNumber: job_number {
        id
        number
        hasJob: has_job
      }
    } 
  }
  ${OperatorInputOperatorFragment}
  ${LeaseInputLeaseFragment}
`;

export const updateMissingTicketDetails = (client, detailsObject) => {
  const variables = {
    input: {
      ...detailsObject,
    },
  };

  const options = {
    mutation: UpdateMissingTicketDetailsMutation,
    variables,
    refetchQueries: [
      {
        query: GetAllTicketNumbersQuery,
      },
    ],
  };

  return client.mutate(options);
};
